import './Text.css';



export function All52() {
  return (
    <div class="body">
      <div class="row" id="GalleryTwo">


        <div class="column">

        </div>


        <div class="column">
            <video autoplay controls loop >

                <source src="All52.mp4" type="video/mp4"/>


            </video>
        </div>


  <div class="column">

    <h4>All52, 2025<br/><br/>
Figma User Interface Design.  </h4>
</div>


      
      </div>
    
    </div>

  );
}
